module.exports = __webpack_public_path__ + "assets/language-squares/zh-CN-4c090f7d86b63eab460377fa1179c648.jpg";